import React, { useRef, useEffect } from 'react';
import { ScrollArea, ScrollBar } from './ui/scroll-area';
import { Button } from './ui/button';
import { LOGO_URL } from '../data/mock';
import {
  Egg,
  Popcorn,
  Beef,
  Salad,
  Wheat,
  Drumstick,
  Flame,
  CakeSlice,
  Coffee,
  GlassWater,
  Sparkles
} from 'lucide-react';

const iconMap = {
  egg: Egg,
  popcorn: Popcorn,
  beef: Beef,
  salad: Salad,
  wheat: Wheat,
  drumstick: Drumstick,
  flame: Flame,
  cakeSlice: CakeSlice,
  coffee: Coffee,
  glassWater: GlassWater,
  sparkles: Sparkles
};

const CategoryNav = ({ categories, activeCategory, onCategorySelect }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    // Auto scroll to active category
    const activeButton = document.querySelector(`[data-category="${activeCategory}"]`);
    if (activeButton && scrollRef.current) {
      activeButton.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }, [activeCategory]);

  return (
    <div className="sticky top-[64px] z-40 bg-neutral-900/95 backdrop-blur-md border-b border-neutral-800 py-4">
      <div className="max-w-7xl mx-auto px-4">
        <ScrollArea className="w-full whitespace-nowrap" ref={scrollRef}>
          <div className="flex space-x-3 pb-2">
            {categories.map((category) => {
              const IconComponent = iconMap[category.icon] || Sparkles;
              const isActive = activeCategory === category.id;
              
              return (
                <Button
                  key={category.id}
                  data-category={category.id}
                  variant="ghost"
                  className={`flex flex-col items-center space-y-2 h-auto py-3 px-4 rounded-xl transition-all duration-300 min-w-[80px] ${
                    isActive
                      ? 'bg-amber-500/20 text-amber-400 border border-amber-500/30'
                      : 'text-neutral-400 hover:text-amber-400 hover:bg-neutral-800'
                  }`}
                  onClick={() => onCategorySelect(category.id)}
                >
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center overflow-hidden transition-all duration-300 ${
                    isActive 
                      ? 'bg-amber-500/30 ring-2 ring-amber-500'
                      : 'bg-neutral-800'
                  }`}>
                    <IconComponent className="w-6 h-6" />
                  </div>
                  <span className="text-xs font-medium whitespace-nowrap">{category.name}</span>
                </Button>
              );
            })}
          </div>
          <ScrollBar orientation="horizontal" className="hidden" />
        </ScrollArea>
      </div>
    </div>
  );
};

export default CategoryNav;